import React, { useState } from 'react';
import AchievementsList from './AchievementsList';
import CharacterCollection from './CharacterCollection';
import { useLanguage } from '../contexts/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';

const AchievementsSection = ({
  achievements,
  recentAchievements,
  totalPracticeTime,
  currentCharacter,
  unlockedCharacters,
  onCharacterSelect
}) => {
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const [activeAchievementTab, setActiveAchievementTab] = useState('achievements');

  const achievementTabs = [
    { id: 'achievements', label: t('yourAchievements'), icon: '🏆' },
    { id: 'characters', label: t('characterCollection'), icon: '🦄' }
  ];

  // 直接使用內聯樣式定義標題顏色 
  const subTitleStyle = {
    fontWeight: 700,
    color: isDark ? '#0ea5e9' : '#6b21a8' // 深色模式使用 sky-500，淺色模式使用 purple-800
  };

  return (
    <div className="space-y-6">
      <div className="text-center max-w-xl mx-auto">
        <h2 className="text-3xl mb-2">
          <span style={subTitleStyle}>{t('yourAchievements')}</span>
        </h2>
        <p className="text-lg text-gray-600 dark:text-gray-300 mx-auto">{t('viewAchievements')}</p>
      </div>

      {/* 成就頁面標籤切換 */}
      <div className="flex justify-center">
        <div className="flex bg-white dark:bg-gray-800 rounded-2xl p-2 shadow-lg">
          {achievementTabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveAchievementTab(tab.id)}
              className={`flex items-center space-x-2 px-6 py-3 rounded-xl font-medium transition-all duration-200 ${
                activeAchievementTab === tab.id
                  ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-md'
                  : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700'
              }`}
            >
              <span className="text-lg">{tab.icon}</span>
              <span className="font-medium">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* 內容區域 */}
      {activeAchievementTab === 'achievements' ? (
        <AchievementsList
          achievements={achievements}
          recentAchievements={recentAchievements}
          totalPracticeTime={totalPracticeTime}
        />
      ) : (
        <div className="max-w-4xl mx-auto">
          <CharacterCollection
            unlockedCharacters={unlockedCharacters}
            currentCharacter={currentCharacter}
            onCharacterSelect={onCharacterSelect}
          />
        </div>
      )}
    </div>
  );
};

export default AchievementsSection;